module.exports = __webpack_public_path__ + "img/exclamation-circle-solid.b0a6441b.svg";